module.exports = __webpack_public_path__ + "media/img/no-results-47b5468f3082b273a56a423cf1b6a005.png";